"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function runInServer() {
    return typeof window === "undefined";
}
exports.runInServer = runInServer;
exports.isSupportWebP = (function () {
    if (runInServer()) {
        return true;
    }
    var elem = document.createElement("canvas");
    if (!!(elem.getContext && elem.getContext("2d"))) {
        return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    else {
        return false;
    }
})();
function transferTens(n) {
    return !n ? 0 : Math.round(n / 10) * 10;
}
exports.transferTens = transferTens;
function dropEmptyValue(arr) {
    return arr.filter(function (item) { return !!item; });
}
exports.dropEmptyValue = dropEmptyValue;
